(() => {
  const variant = document.getElementById('ProductVariant');
  const price = document.querySelector('[data-variant-price]');
  if (variant && price) variant.addEventListener('change', () => { price.textContent = variant.selectedOptions[0].dataset.price; });

  document.querySelectorAll('[data-gallery]').forEach(gallery => {
    const main = gallery.querySelector('.product-main-image');
    const enlarge = gallery.querySelector('[data-photo-enlarge]');
    const zoom = gallery.querySelector('.photo-dialog');
    gallery.querySelectorAll('[data-photo-thumb]').forEach(thumb => thumb.addEventListener('click', event => {
      event.preventDefault(); main.src = thumb.dataset.displaySrc; main.removeAttribute('srcset');
      enlarge.href = thumb.href;
      gallery.querySelectorAll('[data-photo-thumb]').forEach(item => item.removeAttribute('aria-current'));
      thumb.setAttribute('aria-current', 'true');
    }));
    if (zoom && zoom.showModal) {
      enlarge.addEventListener('click', event => { event.preventDefault(); zoom.querySelector('img').src = enlarge.href; zoom.showModal(); });
      zoom.querySelector('.photo-close').addEventListener('click', () => { zoom.close(); enlarge.focus(); });
      zoom.addEventListener('click', event => { if (event.target === zoom) zoom.close(); });
    }
  });

  const catalog = document.querySelector('[data-catalog-tools]');
  if (catalog) {
    const grid = document.querySelector('[data-catalog-grid]');
    const items = Array.from(grid.querySelectorAll('[data-catalog-item]'));
    const search = catalog.querySelector('[data-catalog-search]');
    const sort = catalog.querySelector('[data-catalog-sort]');
    const filters = Array.from(catalog.querySelectorAll('[data-filter]'));
    let selected = filters.some(item => item.dataset.filter === location.hash.slice(1)) ? location.hash.slice(1) : 'all';
    const update = () => {
      const query = search.value.trim().toLowerCase();
      let visible = 0;
      items.forEach(item => {
        const matches = (selected === 'all' || item.dataset.kind === selected || (selected === 'under-25' && Number(item.dataset.price) < 2500)) && item.dataset.name.toLowerCase().includes(query);
        item.hidden = !matches; if (matches) visible++;
      });
      const ordered = [...items];
      if (sort.value === 'price-up') ordered.sort((a,b) => Number(a.dataset.price)-Number(b.dataset.price));
      if (sort.value === 'price-down') ordered.sort((a,b) => Number(b.dataset.price)-Number(a.dataset.price));
      if (sort.value === 'name') ordered.sort((a,b) => a.dataset.name.localeCompare(b.dataset.name));
      ordered.forEach(item => grid.appendChild(item));
      filters.forEach(item => item.setAttribute('aria-pressed', String(item.dataset.filter === selected)));
      catalog.querySelector('[data-catalog-count]').textContent = `${visible} of ${items.length} products`;
      document.querySelector('[data-catalog-empty]').hidden = visible !== 0;
    };
    filters.forEach(button => button.addEventListener('click', () => { selected = button.dataset.filter; update(); }));
    search.addEventListener('input', update); sort.addEventListener('change', update);
    catalog.hidden = false; update();
  }

  const dialog = document.getElementById('AstroClubDialog');
  if (!dialog || !dialog.showModal) return;
  let lastFocus;
  const open = () => { if (dialog.open) return; lastFocus = document.activeElement; dialog.showModal(); };
  const close = () => { dialog.close(); if (lastFocus && lastFocus.focus) lastFocus.focus(); };
  document.querySelectorAll('[data-club-open]').forEach(button => button.addEventListener('click', open));
  dialog.querySelectorAll('[data-club-close]').forEach(button => button.addEventListener('click', close));
  dialog.addEventListener('click', event => { if (event.target === dialog) { const rect = dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close(); } });
})();
